<template>
  <v-row>
    <v-col class="pa-0">
      <v-card-title class="headline"
        >{{ $t("BAItemSession") }} {{ formattedDate }}
        {{ $t("BAItemIn") }}
        {{ sessionSlot.time_start }}
      </v-card-title>
      <v-row>
        <v-col class="py-0">
          <v-list dense class="py-0">
            <v-list-item v-if="order.bill !== null">
              <v-list-item-icon class="mr-3">
                <v-icon>mdi-link</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  ><a @click="alertCopyText(clipboardCopy(order.bill))">{{
                    $t("BAFormBillLink")
                  }}</a>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon class="mr-3">
                <v-icon>mdi-identifier</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ order.id }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon class="mr-3">
                <v-icon>mdi-account</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ order.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon class="mr-3">
                <v-icon>mdi-phone</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ order.phone }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon class="mr-3">
                <v-icon>mdi-percent</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  order.promocode ? order.promocode : "-"
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon class="mr-3">
                <v-icon>mdi-cash</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  class="blue--text lighten-4"
                  v-if="order.order_type === 1 || order.order_type === 4"
                  v-html="
                    $t('BAOrderOrderPrice') + convertPrice(order.purchase)
                  "
                ></v-list-item-title>
                <v-list-item-title v-else>{{ "-" }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon class="mr-3">
                <v-icon>mdi-cash-check</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  class="orange--text"
                  v-if="order.order_type === 1 || order.order_type === 4"
                  v-html="$t('BAOrderPayed') + ' ' + convertPrice(order.paid)"
                ></v-list-item-title>
                <v-list-item-title v-else>{{ "-" }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon class="mr-3">
                <v-icon>mdi-cash-plus</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  class="red--text"
                  v-if="order.order_type === 1 || order.order_type === 4"
                  v-html="
                    (order.need_paid >= 0
                      ? $t('BAOrderToPay')
                      : $t('BAOrderOverPay')) + convertPrice(order.need_paid)
                  "
                ></v-list-item-title>
                <v-list-item-title v-else>{{ "-" }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon class="mr-3">
                <v-icon>mdi-account-tie</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  staffUser ? staffUser.email : "-"
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col class="py-0">
          <v-list dense class="py-0">
            <v-list-item>
              <v-list-item-icon class="mr-3">
                <v-icon>mdi-account-multiple</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ order.persons }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon class="mr-3">
                <v-icon>mdi-comment</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  comments && comments.length ? comments[0].text : "-"
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon class="mr-3">
                <v-icon>mdi-at</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  order.email ? order.email : "-"
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="order.user && order.user.loyalty_card_id">
              <v-list-item-icon class="mr-3">
                <v-icon>mdi-smart-card-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  order.user.loyalty_card_id
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon class="mr-3">
                <v-icon>mdi-information-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  class="blue--text"
                  v-if="order.order_type == 3"
                  v-html="$t('BAOrderFree')"
                ></v-list-item-title>
                <v-list-item-title
                  class="purple--text"
                  v-else-if="order.order_type == 4"
                  v-html="$t('BAFormEvent')"
                ></v-list-item-title>
                <v-list-item-title
                  class="blue--text"
                  v-else-if="order.order_type == 2"
                  v-html="$t('BAOrderTech')"
                ></v-list-item-title>
                <v-list-item-title v-else>{{ "-" }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon class="mr-3">
                <v-icon>mdi-gamepad-square-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  order.game ? order.game.name : "-"
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon class="mr-3">
                <v-icon>mdi-account-multiple-plus</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  orderUser ? orderUser.email : "-"
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
      <v-card-actions class="flex-wrap">
        <v-dialog v-model="dialogPayOrder" persistent width="500">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="green darken-1" text v-bind="attrs" v-on="on"
              >{{ $t("BAOrderPay") }}
            </v-btn>
          </template>
          <v-card tile>
            <v-card-title class="headline"
              >{{ $t("BAOrderPayment") }} {{ order.id }}</v-card-title
            >
            <v-card-text>
              <v-text-field
                :label="$t('BAOrderTotal')"
                class="mt-4"
                name="value"
                dense
                type="text"
                required
                v-model="payment.purchase"
                :error-messages="paymentPurchaseErrors"
                @input="$v.payment.purchase.$touch()"
                @blur="$v.payment.purchase.$touch()"
              ></v-text-field>
              <v-select
                :items="payment_types"
                :label="$t('BAOrderPaymentType')"
                v-model="payment.payment_type"
                item-text="name"
                item-value="id"
              ></v-select>
              <v-text-field
                v-if="payment.payment_type == 3"
                :label="$t('BAOrderCertificate')"
                class="mt-4"
                name="certificate"
                dense
                type="text"
                required
                v-model="payment.external_id"
                :error-messages="paymentCertificateErrors"
                @input="$v.payment.external_id.$touch()"
                @blur="$v.payment.external_id.$touch()"
              ></v-text-field>
              <small>* {{ $t("validation") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                text
                @click="payOrder(order.id), (dialogPayOrder = false)"
                :disabled="$v.$invalid"
                >{{ $t("btnPay") }}
              </v-btn>
              <v-btn
                color="red darken-1"
                text
                @click="dialogPayOrder = false"
                >{{ $t("btnExit") }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-btn color="green darken-1" text @click.stop="openedDialogForm">{{
          $t("BAFormEdit")
        }}</v-btn>
        <booking-admin-form
          v-if="!sessionSlot.isArchived"
          :order="order"
          :sessionSlot="sessionSlot"
          :selectedDay="selectedDay"
          :dialogForm="dialogForm"
          @close-dialog="dialogForm = false"
          @close-form="dialogForm = false"
          @reload-schedule="changeOrder()"
        ></booking-admin-form>
        <v-dialog v-model="dialogFormMulti" persistent width="1400">
          <booking-admin-form-multi
            v-if="!sessionSlot.isArchived"
            :order="order"
            :sessionSlot="sessionSlot"
            :selectedDay="selectedDay"
            :dialogFormMulti="dialogFormMulti"
            @close-dialog="dialogFormMulti = false"
            @close-form="dialogFormMulti = false"
            @reload-schedule="changeOrder()"
          ></booking-admin-form-multi>
        </v-dialog>
        <v-dialog
          v-if="!sessionSlot.isArchived"
          v-model="dialogRemoveOrder"
          width="500"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="red darken-1" text v-bind="attrs" v-on="on"
              >{{ $t("BAOrderCancel") }}
            </v-btn>
          </template>
          <v-card tile>
            <v-card-title class="headline"
              >{{ $t("BAOrderCancel") }} {{ order.id }}?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red darken-1"
                text
                @click="removeOrder(order.id), (dialogRemoveOrder = false)"
                >{{ $t("btnYes") }}
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                @click="dialogRemoveOrder = false"
                >{{ $t("btnNo") }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="alert" max-width="500">
          <template v-slot:default="dialog">
            <v-card tile>
              <v-card-title>
                <div class="headline">
                  {{ $t("link_to_pay1") }} {{ order.id }} <br />
                  {{ $t("link_to_pay2") }}
                </div>
              </v-card-title>
              <v-card-actions class="justify-end">
                <v-btn text @click="dialog.value = false">Close</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-card-actions>
    </v-col>
    <v-col
      style="background: rgb(238, 238, 238)"
      class="d-flex flex-column pa-0"
      v-if="comments"
    >
      <v-card-title class="headline">{{ $t("BAItemLog") }}</v-card-title>
      <v-list class="transparent py-0" dense>
        <v-list-item v-for="(comment, k) in comments" :key="k">
          <span class="font-weight-medium mr-3"
            >{{ comment.created | dateFormat }},
            {{ comment.created | timeFormat }}:</span
          >
          <span v-if="comment && comment.text">{{ comment.text }}</span>
          <span v-if="comment && comment.data">{{ comment.data }}</span>
        </v-list-item>
      </v-list>
      <v-card-actions class="mt-auto" v-if="comments">
        <v-dialog v-model="dialogLog" width="500">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="green darken-1" text v-bind="attrs" v-on="on"
              >{{ $t("BAOrderMore") }}
            </v-btn>
          </template>
          <v-card tile>
            <v-card-title class="headline"
              >{{ $t("BAOrderLog") }} {{ order.id }}</v-card-title
            >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">{{ $t("BAOrderDate") }}</th>
                    <th class="text-left">{{ $t("BAOrderTime") }}</th>
                    <th class="text-left">{{ $t("BAOrderType") }}</th>
                    <th class="text-left">{{ $t("BAOrderActions") }}</th>
                    <th class="text-left">{{ $t("BAOrderAuthor") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(comment, k) in comments" :key="k">
                    <td>{{ comment.created | dateFormat }}</td>
                    <td>{{ comment.created | dateFormat }}</td>
                    <td>{{ comment && comment.type ? comment.type : "-" }}</td>
                    <td>{{ comment && comment.text ? comment.text : "-" }}</td>
                    <td>
                      {{
                        comment && comment.author ? comment.author.name : "-"
                      }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-dialog>
      </v-card-actions>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import BookingAdminForm from "@/components/BookingAdminForm.vue";
import BookingAdminFormMulti from "@/components/BookingAdminFormMulti";
import moment from "moment";

export default {
  name: "BookingAdminOrder",

  mixins: [validationMixin],

  props: ["order", "sessionSlot", "selectedDay"],

  data() {
    return {
      dialogRemoveOrder: false,
      dialogPayOrder: false,
      dialogLog: false,
      dialogForm: false,
      dialogFormMulti: false,
      alert: false,
      payment_types: [
        {
          id: 2,
          name: this.$i18n.t("BAOrderPaymentCash"),
        },
        {
          id: 3,
          name: this.$i18n.t("BAOrderPaymentCertificate"),
        },
        {
          id: 4,
          name: this.$i18n.t("BAOrderPaymentBill"),
        },
        {
          id: 6,
          name: this.$i18n.t("BAOrderPaymentCard"),
        },
      ],
      payment: {
        payment_type: 2,
        purchase: "",
        external_id: "",
      },
      comments: null,
    };
  },

  computed: {
    ...mapGetters(["orderUser", "staffUser"]),
    paymentPurchaseErrors() {
      const errors = [];
      if (!this.$v.payment.purchase.$dirty) return errors;
      !this.$v.payment.purchase.required &&
        errors.push(this.$i18n.t("validationSum"));
      return errors;
    },
    paymentCertificateErrors() {
      const errors = [];
      if (!this.$v.payment.external_id.$dirty) return errors;
      !this.$v.payment.external_id.required &&
        errors.push(this.$i18n.t("validationCertificate"));
      return errors;
    },
    formattedDate() {
      return this.sessionSlot
        ? this.moment(this.sessionSlot.begin).format("DD.MM.YYYY")
        : "";
    },
  },

  filters: {
    dateFormat: (date) => {
      return moment.parseZone(date).format("DD.MM.YYYY");
    },
    timeFormat: (date) => {
      return moment.parseZone(date).format("HH:mm");
    },
  },

  validations: {
    payment: {
      purchase: {
        required,
      },
      external_id: {
        required: requiredIf(function () {
          return this.payment.payment_type === 3;
        }),
      },
    },
  },

  components: { BookingAdminFormMulti, BookingAdminForm },

  methods: {
    ...mapActions([
      "removeBAOrder",
      "payBAOrder",
      "loadBAOrderComments",
      "loadOrderUser",
      "loadStaffUser",
      "resetStateOrderUser",
      "resetStateStaffUser",
    ]),
    removeOrder(id) {
      let self = this;
      self.removeBAOrder(id).then(() => {
        self.$emit("remove-order", id);
      });
    },
    payOrder(id) {
      let self = this;
      self
        .payBAOrder({
          order_id: id,
          payment: self.payment,
        })
        .then(() => {
          self.$emit("pay-order");
        });
    },
    changeOrder() {
      this.$emit("change-order");
    },
    convertPrice(value) {
      let price = new Intl.NumberFormat(
        navigator.language.split("-")[0]
      ).format(value);

      if (this.sessionSlot.pricing.currency.is_before) {
        return (
          this.sessionSlot.pricing.currency.code +
          this.sessionSlot.pricing.currency.blank_place +
          price
        );
      } else {
        return (
          price +
          this.sessionSlot.pricing.currency.blank_place +
          this.sessionSlot.pricing.currency.code
        );
      }
    },
    alertCopyText() {
      this.alert = true;
    },
    clipboardCopy: (text) => navigator.clipboard.writeText(text),
    openedDialogForm() {
      if (this.order.multisession) {
        return (this.dialogFormMulti = true);
      }
      return (this.dialogForm = true);
    },
  },
  mounted() {
    this.loadBAOrderComments(this.order.id).then((response) => {
      if (response.data) {
        this.comments = response.data;
      }
    });
    this.order.seller_user_id
      ? this.loadOrderUser(this.order.seller_user_id)
      : this.resetStateOrderUser();
    this.order.staff_user_id
      ? this.loadStaffUser(this.order.staff_user_id)
      : this.resetStateStaffUser();
  },
  watch: {
    dialogPayOrder(visible) {
      if (!visible) {
        this.$v.$reset();
      }
    },
  },
};
</script>
